import { useParams } from 'react-router-dom';
import LocationForm from './LocationForm';
import React from 'react';

export default function ValidationForms() {
  let { id } = useParams();
  return <LocationForm id={id} />;
}
